import "./exhaust-fan-turbo.css";
import { NavLink, useNavigate } from "react-router-dom";

import axios from 'axios';
import Slider from 'react-slick';
import React, { useState, useEffect, useRef } from "react";
import FadeInSection from "../FadeInup/FadeInup";
import { LazyLoadImage } from 'react-lazy-load-image-component';
// import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-lazy-load-image-component/src/effects/blur.css';
import moment from "moment";
import { Helmet } from 'react-helmet';
import TurboHead from "./TurboHead";






function ExhaustFanTurbo(props) {
    const [price, setprice] = useState(null)
    const [discountedprice, setdiscountedprice] = useState(null)
    const [fixedprice, setfixedprice] = useState(null)
    const [fixeddiscountedprice, setfixeddiscountedprice] = useState(null)
    const navigate = useNavigate();
    const [product, setproduct] = useState([])
    const [product_Name, setProduct_Name] = useState("exhaust")
    const [product_Description, setProduct_Description] = useState("The Ultimate fun for home, featuring 5-star BLDC motor, inverter-friendly technology, higher air delivery, stylish design and remote. Get longer product protection with a 2+2 years warranty.")
    const [itemName, setItemName] = useState("")

    const [inventory, setInventory] = useState(0)

    // LOADER CODE
    const [showLoader, setShowLoader] = useState(true)

    const getproduct = async () => {
        try {
            await fetch(`${process.env.REACT_APP_PROD_URL}/ColorBotGetProduct`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${window.localStorage.getItem('token')}`
                },

                body: JSON.stringify({ type: "exhaust", productfor: "Normal",category:"ecoz_turbo" }),
            }).then((res) => res.json()).then((response) => {


                if (response.status === 200) {
                    setproduct(response.data)
                    setprice(response.data[0].ProductPrice)
                    setdiscountedprice(response.data[0].ProductSelling)
                    setfixedprice(response.data[0].ProductPrice)
                    setfixeddiscountedprice(response.data[0].ProductSelling)

                    setProduct_Name(response.data[0].ProductName)
                    setProduct_Description(response.data[0].ProductDescription)
                    setItemName(response.data[0].ItemNo)
                    setInventory(response.data[0].ProductInventory)

                    var set = new Set();
                    var set1 = new Set();
                    for (let i = 0; i < response.data.length; i++) {


                        set.add(response.data[i].ProductSize)




                    }
                    var data = response.data.filter((item) => {
                        return item.ProductSize === response.data[0].ProductSize
                    })
                    for (let i = 0; i < data.length; i++) {
                        set1.add(data[i].ProductColorCode)
                    }
                    var arr = Array.from(set)
                    var arr1 = Array.from(set1)

                    for (let i = 0; i < arr1.length; i++) {
                        if (arr1[i] === "#000000") {
                            colorlist[0].available = true
                        }
                      
                        if (arr1[i] === "#d8d8d8") {
                            colorlist[1].available = true
                        }
                        if (arr1[i] === "#6d6d6d") {
                            colorlist[2].available = true
                        }
                        if (arr1[i] === "#830B00") {
                            colorlist[3].available = true
                        }
                        if (arr1[i] === "#F0F0F0") {
                            colorlist[4].available = true
                        }
                       
                    }

                    for (let i = 0; i < buttonlist.length; i++) {
                        buttonlist[i].available = false;  // Set all buttons to false initially
                    }

                    setcolorlist(colorlist)
                    for (let i = 0; i < arr.length; i++) {
                        if (arr[i] === "150mm") {
                            buttonlist[0].available = true
                        }
                        if (arr[i] === "200mm") {
                            buttonlist[1].available = true
                        }
                        if (arr[i] === "250mm") {
                            buttonlist[2].available = true
                        }
                    }
                    setbuttonlist(buttonlist)


                    setbuttonactive(response.data[0].ProductSize)
                    if (localStorage.getItem("exhaust_type") === "ecoz_turbo") {
                        setactivecolor(localStorage.getItem("exhaust_color"))
                        setbuttonactive(localStorage.getItem("exhaust_size"))
                        setTimeout(() => {
                            document.getElementById(`size-${localStorage.getItem("exhaust_size")}`).click()
                        }, 300)
                        setShowLoader(false)

                    } else {
                        setactivecolor(response.data[0].ProductColorCode)
                        var imagearr = []
                        imagearr.push(response.data[0].ProductImage)
                        imagearr.push(response.data[0].ProductImage1)
                        imagearr.push(response.data[0].ProductImage2)
                        imagearr.push(response.data[0].ProductImage3)
                        imagearr.push(response.data[0].ProductImage4)
                        imagearr.push(response.data[0].ProductImage5)
                        for (let i = 0; i < 6; i++) {
                            imagearr.push(imagearr[i])
                        }

                        setimage(imagearr)
                        setimageselected(response.data[0].ProductImage)
                        setShowLoader(false)
                    }



                } else {
                    setproduct([])
                    setShowLoader(false)


                }
            })
        } catch (error) {
            setShowLoader(false)
            console.log(error)
        }
    }

    const [buttonlist, setbuttonlist] = useState([
        {
            value: "150mm",
            available: false,

        },
        {
            value: "200mm",
            available: false,

        }, {
            value: "250mm",
            available: false,

        }
    ])
    const [imageselected, setimageselected] = useState("")
    const [image, setimage] = useState([])
    const [buttonactive, setbuttonactive] = useState("150mm")
    const [activecolor, setactivecolor] = useState("#000000")
    const [quantity, setquantity] = useState(1)
   const [colorlist, setcolorlist] = useState([
           {
               value: "Charcoal black",
               color: "#000000",
               secondary: "#000000",
               available: false
           }, {
               value: "Artic white",
               color: "#d8d8d8",
               secondary: "#d8d8d8",
               available: false
           }, {
               value: "Ash grey",
               color: "#6d6d6d",
               secondary: "#6d6d6d",
               available: false
           }, {
               value: "Classic Maroon",
               color: "#830B00",
               secondary: "#830B00",
               available: false
           },
           {
               value: "Noir white",
               color: "#F0F0F0",
               secondary: "#000000",
               available: false
           } 
       ])
    
    const [pincode, setPincode] = useState('');
    const [city, setCity] = useState('');

    const [state, setState] = useState('');
    const [error, setError] = useState('');


    const checkpincode = () => {
        setCity('');
        setState('');
        var value = pincode;

        if (value.length === 6) {
            setError('');

            axios
                .get(`https://api.postalpincode.in/pincode/${value}`)
                .then((res) => {
                    setState(res.data[0].PostOffice[0].State);
                    setCity(res.data[0].PostOffice[0].Block);


                })
                .then(() => {

                })
                .catch((err) => {

                    setError('Invalid PIN Code');
                });
        }

        if (value.length !== 6) {
            setCity('');

            setState('');
            setError('Pincode must be of 6 digits');
        }

    } 
    const [showMore, setShowMore] = useState(false)
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        arrow: true,
        autoplaySpeed: 2000,
        autoplay: true,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1002,
                settings: {
                    slidesToShow: 4
                }
            }
        ]
    };




    useEffect(() => {
        getproduct()

        window.scrollTo(0, 0, {
            behavior: 'smooth'
        })


    }, [])

   


  
  




    const buyproduct = () => {
        var productprice = Number(quantity * parseInt(price));
        var productdiscountedprice = Number(quantity * parseInt(discountedprice));
        var productname = product_Name;
        var productimage = image[0]
        var productcolor = getActiveColorName();
        var productquantity = quantity;
        var productsweepsize = buttonactive;
        var productid = itemName
        var productremote = ""
        var newItem = {
            "productid": productid,
            "productname": productname,
            "productimage": productimage,
            "productprice": productprice,
            "productdiscountedprice": productdiscountedprice,
            "fixedproductprice": Number(fixedprice),
            "fixedproductdiscountedprice": Number(fixeddiscountedprice),
            "productpath": window.location.pathname,
            "productcolor": productcolor,
            "inventory": inventory,
            "extendedwarranty": true,
            "modal": "Helix",
            "productquantity": productquantity,
            "productsweepsize": productsweepsize,
            "productremote": productremote
        }
        addToCart(newItem);
        window.localStorage.setItem("cartdate", moment().format("DD-MM-YYYY HH:mm:ss"))
        if (props.LoggedIn) {

            navigate("/product_buy_now_delivery")
        } else {
            navigate("/product_buy_now_login")
        }

    }
    const addtocart = () => {

        var productprice = Number(quantity * parseInt(price));
        var productdiscountedprice = Number(quantity * parseInt(discountedprice));
        var productname = product_Name;
        var productimage = image[0]
        var productcolor = getActiveColorName();
        var productquantity = quantity;
        var productsweepsize = buttonactive;
        var productid = itemName
        var productremote = ""
        var newItem = {
            "productid": productid,
            "productname": productname,
            "productimage": productimage,
            "productprice": productprice,
            "productdiscountedprice": productdiscountedprice,
            "fixedproductprice": Number(fixedprice),
            "fixedproductdiscountedprice": Number(fixeddiscountedprice),
            "productpath": window.location.pathname,
            "productcolor": productcolor,
            "inventory": inventory,
            "modal": "Helix",
            "extendedwarranty": true,
            "productquantity": productquantity,
            "productsweepsize": productsweepsize,
            "productremote": productremote
        }

        addToCart(newItem);
        window.localStorage.setItem("cartdate", moment().format("DD-MM-YYYY HH:mm:ss"))
        props.opensidepanel()
    }
    const addToCart = (newItem) => {


        props.setcartdata((prevData) => {
            const existingItemIndex = prevData.findIndex(
                (item) => item.productid === newItem.productid
            );

            if (existingItemIndex !== -1) {
                const updatedData = prevData.map((item, index) => {
                    if (index === existingItemIndex) {
                        // Update the quantity of the existing item
                        const updatedQuantity = parseInt(item.productquantity) + parseInt(newItem.productquantity);
                        const updatedPrice = parseInt(item.productprice) + parseInt(newItem.productprice);
                        const updatedDiscountedPrice = parseInt(item.productdiscountedprice) + parseInt(newItem.productdiscountedprice);
                        return { ...item, productquantity: updatedQuantity, productprice: updatedPrice, productdiscountedprice: updatedDiscountedPrice };
                    }
                    return item;
                });

                localStorage.setItem('cartdata', JSON.stringify(updatedData));
                window.localStorage.setItem("cartdate", moment().format("DD-MM-YYYY HH:mm:ss"))
                window.localStorage.setItem("addcart", true)
                return updatedData;
            }

            const updatedData = [...prevData, newItem];
            localStorage.setItem('cartdata', JSON.stringify(updatedData));
            window.localStorage.setItem("cartdate", moment().format("DD-MM-YYYY HH:mm:ss"))
            window.localStorage.setItem("addcart", true)
            return updatedData;
        });
    };


 
    const handleChangeQuantity = (newQuantity) => {
        if (newQuantity === "" || newQuantity === 0) {
            // toast.error("Please enter a valid Quantity"); // Display an error toast notification
            setquantity(newQuantity);

        } else {
            setquantity(newQuantity);


        }
    };

    const getActiveColorName = () => {
        const activeColorObject = colorlist.find(color => color.color === activecolor);
        return activeColorObject ? activeColorObject.value : "";
    };

    useEffect(() => {
        getActiveColorName()
    }, [activecolor])

    const getpairedproduct = async (colorcode) => {
        setactivecolor(colorcode)
        var data = product.filter((item) => {
            return item.ProductColorCode === colorcode && item.ProductSize === buttonactive
        })
        if (data.length > 0) {
            var set = new Set();

            for (let i = 0; i < data.length; i++) {

                if (product[i].ProductColorCode == colorcode) {

                    set.add(product[i].ProductSize)
                }




            }
            var arr = Array.from(set)

            // for (let i = 0; i < buttonlist.length; i++) {
            //     buttonlist[i].available = false;  // Set all buttons to false initially
            // }


            for (let i = 0; i < arr.length; i++) {
                if (arr[i] === "150mm") {
                    buttonlist[0].available = true
                }
                if (arr[i] === "200mm") {
                    buttonlist[1].available = true
                }
                if (arr[i] === "250mm") {
                    buttonlist[2].available = true
                }
            }
            setbuttonlist(buttonlist)

            setbuttonactive(data[0].ProductSize)

            setprice(data[0].ProductPrice)
            setdiscountedprice(data[0].ProductSelling)
            setfixedprice(data[0].ProductPrice)
            setfixeddiscountedprice(data[0].ProductSelling)
            setProduct_Name(data[0].ProductName)
            setProduct_Description(data[0].ProductDescription)
            setItemName(data[0].ItemNo)
            setInventory(data[0].ProductInventory)
            var imagearr = []
            imagearr.push(data[0].ProductImage)
            imagearr.push(data[0].ProductImage1)
            imagearr.push(data[0].ProductImage2)
            imagearr.push(data[0].ProductImage3)
            imagearr.push(data[0].ProductImage4)
            imagearr.push(data[0].ProductImage5)
            for (let i = 0; i < 6; i++) {
                imagearr.push(imagearr[i])
            }

            setimage(imagearr)
            setimageselected(data[0].ProductImage)
            setquantity(1)

        }
    }

    const getsizepairedproduct = async (size) => {
        setbuttonactive(size);
        var data = product.filter((item) => {
            return item.ProductSize === size
        })

     

        if (data.length > 0) {

            var set = new Set();
            var set1 = new Set();

            for (let i = 0; i < product.length; i++) {

                if (product[i].ProductColorCode == activecolor) {

                    set.add(product[i].ProductSize)
                }




            }
            

            // setactivecolor(data[0].ProductColorCode)
            for (let i = 0; i < data.length; i++) {




                set1.add(data[i].ProductColorCode)


            }
            for (let i = 0; i < colorlist.length; i++) {
                colorlist[i].available = false;  // Set all buttons to false initially
            }

        


            var arr1 = Array.from(set1)


            for (let i = 0; i < arr1.length; i++) {
                if (arr1[i] === "#000000") {
                    colorlist[0].available = true
                }
               
              
                if (arr1[i] === "#d8d8d8") {
                    colorlist[1].available = true
                }
                if (arr1[i] === "#6d6d6d") {
                    colorlist[2].available = true
                }
                if (arr1[i] === "#830B00") {
                    colorlist[3].available = true
                }
                if (arr1[i] === "#F0F0F0") {
                    colorlist[4].available = true
                }
              
            }

            
            setcolorlist(colorlist)

            var arr = Array.from(set)



            for (let i = 0; i < arr.length; i++) {
                if (arr[i] === "150mm") {
                    buttonlist[0].available = true
                }
                if (arr[i] === "200mm") {
                    buttonlist[1].available = true
                }
                if (arr[i] === "250mm") {
                    buttonlist[2].available = true
                }
            }
            setbuttonlist(buttonlist)
            for (let i = 0; i < data.length; i++) {
                if (arr1.includes(activecolor) && data[i].ProductColorCode === activecolor && data[i].ProductSize === size) {

                    setactivecolor(activecolor)
                    setprice(data[i].ProductPrice)
                    setdiscountedprice(data[i].ProductSelling)
                    setfixedprice(data[i].ProductPrice)
                    setfixeddiscountedprice(data[i].ProductSelling)
                    setProduct_Name(data[i].ProductName)
                    setProduct_Description(data[i].ProductDescription)
                    setItemName(data[i].ItemNo)
                    setInventory(data[i].ProductInventory)
                    var imagearr = []
                    imagearr.push(data[i].ProductImage)
                    imagearr.push(data[i].ProductImage1)
                    imagearr.push(data[i].ProductImage2)
                    imagearr.push(data[i].ProductImage3)
                    imagearr.push(data[i].ProductImage4)
                    imagearr.push(data[i].ProductImage5)
                    for (let i = 0; i < 6; i++) {
                        imagearr.push(imagearr[i])
                    }

                    setimage(imagearr)
                    setimageselected(data[i].ProductImage)
                    setquantity(1)


                } else {
                    setactivecolor(arr1[0])
                    setprice(data[0].ProductPrice)
                    setdiscountedprice(data[0].ProductSelling)
                    setfixedprice(data[0].ProductPrice)
                    setfixeddiscountedprice(data[0].ProductSelling)
                    setProduct_Name(data[0].ProductName)
                    setProduct_Description(data[0].ProductDescription)
                    setItemName(data[0].ItemNo)
                    setInventory(data[0].ProductInventory)
                    var imagearr = []
                    imagearr.push(data[0].ProductImage)
                    imagearr.push(data[0].ProductImage1)
                    imagearr.push(data[0].ProductImage2)
                    imagearr.push(data[0].ProductImage3)
                    imagearr.push(data[0].ProductImage4)
                    imagearr.push(data[0].ProductImage5)
                    for (let i = 0; i < 6; i++) {
                        imagearr.push(imagearr[i])
                    }

                    setimage(imagearr)
                    setimageselected(data[0].ProductImage)
                    setquantity(1)
                }
            }

        }
    }

    const ShareInfo = () => {

        if (navigator.share) {
            navigator.share({
                title: "Color Bot",
                text: product_Name,
                url: window.location.href
            }).then(() => {
                console.log('Share successful');
            }).catch((error) => {
                console.error('Error sharing:', error);
            });
        } else {
            // Fallback for browsers that do not support Web Share API
            console.log('Web Share API not supported.');
            // Implement your own custom share functionality here
        }
    };




    var month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const convertdate = (date) => {
        var d = date.split("-")[0];
        var m = date.split("-")[1];

        var time = " " + d + "th" + " " + month[parseInt(m) - 1];

        return time;
    }
    const convertdatewithoutMonth = (date) => {
        var d = date.split("-")[0];
        var m = date.split("-")[1];

        var time = d + "th" + " ";

        return time;
    }


    
    return (

        showLoader ? <>
            <section className="mt-5 pt-4 loader-align">
                <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/loader-gif.gif"></img>
                <p>LOADING COLORBOT...</p>
            </section>
        </>
            :
            <>
                <section className="mt-5 pt-4">
                    <TurboHead />
                    <div className="shopnow">
                        FREE SHIPPING on all prepaid orders, <span><NavLink to="/exhuast">SHOP NOW</NavLink></span>
                    </div>
                    <div className="container pt-4">
                        <p className="breadcrumb"> <a style={{ color: "#000000" }} href="/" > Home </a> &nbsp;<i className="fa fa-angle-right"></i>&nbsp; <a style={{ color: "#000000" }} href="/exhaust-fan" > BLDC Exhuast Fans </a>  &nbsp;<i className="fa fa-angle-right"></i>&nbsp; <span style={{ color: "#1428A1", fontSize: "13px" }}>
                            Exhuast</span></p>
                        {product.length > 0 ? <div className="row justify-content-center pt-2">

                            <div className="col-md-12 col-lg-6 pt-2 prod-img-pad">
                                <LazyLoadImage src={imageselected}
                                    width={"100%"}
                                    alt="helixproduct" className="img-fluid darkimage"
                                    effect="blur"
                                />

                                <Slider {...settings} className="helix slick-sliderdark">
                                    {image.map((item, index) => {
                                        return (
                                            <div className="helixmultiple" key={index}>
                                                <LazyLoadImage src={item} onClick={() => {

                                                    setimageselected(item)
                                                }} className={`${imageselected}` === item ? "img-fluid heliximageactive" : "img-fluid"} alt="helixproduct"
                                                    effect="blur" width={"100%"}
                                                />

                                            </div>
                                        )
                                    })}

                                </Slider>
                            </div>
                            <div className="col-md-12 col-lg-6 pt-2">
                                <h1 className="helixproductname producttop">{product_Name}</h1>
                                <p className="helixsubproductname producttop">{product_Description}</p>

                                <span className="helixprice producttop">₹ {discountedprice} <span className="helixmainprice"> {price}</span> <span className="helixdiscount">-{(((price - discountedprice) / price) * 100).toFixed(0)}%</span></span>

                                <p className="line"></p>

                               
                                <div className="helixbuttonoption producttop">
                                    <span className="remotename">Sweep Size:</span>
                                    &nbsp;&nbsp;&nbsp;
                                    <div className="buttonlist">
                                        {buttonlist.map((item, index) => {

                                            return !item.available ? (
                                                <button id={`size-${item.value}`} className={item.value === buttonactive ? "helixbuttonlist helixbuttonactive" : "helixbuttonlist diagonalCross2"} disabled={!item.available} key={index} onClick={() => {

                                                    getsizepairedproduct(item.value);



                                                }}>{item.value}</button>

                                            ) : (
                                                <button id={`size-${item.value}`} className={item.value === buttonactive ? "helixbuttonlist helixbuttonactive" : "helixbuttonlist "} disabled={!item.available} key={index} onClick={() => {

                                                    getsizepairedproduct(item.value);



                                                }}>{item.value}</button>
                                            )
                                        })}

                                    </div>

                                </div>
                                <div className="helixbuttonoption producttop">
                                    <span className="remotename">Color:</span>
                                    &nbsp;
                                    <span className="helixcolor text-left">{getActiveColorName()}</span>
                                    <br />


                                </div>

                                <div className="helixcolorlist color-list ">
                              
                                    {colorlist.filter((item)=>item.available).map((item, index) => {
                                        return item.available?(
                                            <div
                                                className={item.color === activecolor ? "helixcolorlistitem helixcoloractive" : "helixcolorlistitem"}
                                                key={item.color + index}

                                                id={`color-${item.color}`}
                                                onClick={() => {
                                                    if (item.available) {
                                                        
                                                        getpairedproduct(item.color);
                                                    }
                                                }}
                                                style={{
                                                    transform: "rotate(90deg)",
                                                    background: `conic-gradient(${item.secondary} 0deg 180deg, ${item.color} 180deg 360deg)`,
                                                    pointerEvents: !item.available ? "none" : "auto", // Disable interaction when item is available
                                                    opacity: !item.available ? 1 : 1, // Optionally reduce opacity for visual indication of disabled state
                                                }}
                                            >
                                                <div className={!item.available ? "helixcolorlistitemdiagonal" : ""}>

                                                </div>
                                            </div>
                                        ):null
                                    })}
                                </div>

                                <div className="helixquantity producttop">
                                    <span className="remotename">Quantity:</span>
                                    &nbsp;&nbsp;&nbsp;

                                    <input
                                        type="number"
                                        className="helixselect"
                                        value={quantity}
                                        onChange={(e) => {

                                            const inputValue = parseInt(e.target.value, 10);

                                            if (inputValue < 0 || inputValue > 99) {
                                                // If the input is invalid, you can choose to handle it here.
                                                // For example, you might want to show an error message or prevent further processing.
                                                return;
                                            }
                                            handleChangeQuantity(e.target.value)

                                        }}
                                    />
                                    <span className="helixshare" onClick={() => {
                                        ShareInfo()
                                    }}>Share &nbsp; <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/share.svg" alt="share" className="img-fluid" /> </span>

                                </div>

                                {inventory > 0 && parseInt(quantity) <= parseInt(inventory) ? <div className="helixbutton">
                                    <button id="helix-fan-buynow" className={quantity > 0 ? "helixbuynow" : "helixbuynow disabled"} disabled={quantity > 0 ? false : true} onClick={() => {
                                        buyproduct()
                                    }}>Buy Now</button>
                                    <button id="helix-fan-addcart" className={quantity > 0 ? "helixaddtocart" : "helixaddtocart disabled"} disabled={quantity > 0 ? false : true} onClick={() => {
                                        addtocart()

                                    }}>Add to Cart</button>
                                </div> : <p className="text-danger text-center">Out of stock!</p>}
                                <div className="helixwarranty">
                                    <LazyLoadImage src={"https://colorbots3.s3.ap-south-1.amazonaws.com/2yearwarranty.svg"}
                                        width={"100%"}
                                        className=" img-fluid lazysupportimg" alt="2yearwarranty"
                                        effect="blur"
                                    />
                                    <LazyLoadImage src={"https://colorbots3.s3.ap-south-1.amazonaws.com/freeshipping.svg"}
                                        width={"100%"}
                                        className=" img-fluid lazysupportimg" alt="freeshipping"
                                        effect="blur"
                                    />
                                    <LazyLoadImage src={"https://colorbots3.s3.ap-south-1.amazonaws.com/easyinstallation.svg"}
                                        width={"100%"}
                                        className=" img-fluid lazysupportimg" alt="easyinstallation"
                                        effect="blur"
                                    />
                                    <LazyLoadImage src={"https://colorbots3.s3.ap-south-1.amazonaws.com/5star.svg"}
                                        width={"100%"}
                                        className=" img-fluid lazysupportimg" alt="5star"
                                        effect="blur"
                                    />

                                </div>

                                <div className="amazon-flipkart producttop">
                                    <p><b>Also Available on : &nbsp;</b>   <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/Amazon.svg" className="img-fluid" alt="amazon" /> &nbsp; <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/Flipkart.svg" className="img-fluid" alt="flipkart" /></p>
                                </div>
                                <div className="pincodechecker">
                                    <div>
                                        <input type="text" className="helixpincode form-control-sm" maxLength={6} placeholder="Pincode" value={pincode} onChange={(e) => {
                                            setPincode(e.target.value);
                                            setCity('');
                                            setState('');
                                            setError('')
                                        }} />
                                        <button className="helixcheck" onClick={() => {
                                            checkpincode();
                                        }}>Check</button>
                                    </div>
                                    <NavLink to="https://colorbots3.s3.ap-south-1.amazonaws.com/Buyers+Guid/Buyers-Guid.pdf" target="blank" >  <span className="buyinguide">Fan Buying Guide &nbsp; <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/pdf.svg" className="img-fluid" alt="pdf" /></span> </NavLink>
                                </div>
                                <div className="Address">
                                    {state !== "" ? <span className="subaddress" >{city} / {state}, {pincode} <br />Delivery by {convertdatewithoutMonth(moment().add(4, 'days').format("DD-MM-YYYY"))}-{convertdate(moment().add(7, 'days').format("DD-MM-YYYY"))}</span> : ""}
                                    <span className="error">{error}</span>
                                </div>
                                <br />
                            </div>
                        </div> : <p className="text-center text-dark m-4">No Products Available</p>}

                    </div>
                </section>
                <section className="banner1-bg-img">
                    <div className="container">
                        <div className="row align-colms">
                            <div className="col-lg-4">
                                <div className="exhaust-card1">
                                    <div className="efiicent-motor">
                                        <div className="efiicnt-img">
                                            <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/exhaust/Efficient-icn.svg" alt="" />

                                        </div>
                                        <div className="efiicent-txt">
                                            <h3>Efficient with BLDC Motor</h3>
                                            <p>Upgrade your space with Colorbot Stella BLDC exhaust fan that is designed for maximum
                                                performance at minimum energy consumption.</p>
                                        </div>
                                    </div>

                                    <div className="efiicent-motor">
                                        <div className="efiicnt-img"><img src="https://colorbots3.s3.ap-south-1.amazonaws.com/exhaust/Copper-icn.svg" alt="" /></div>
                                        <div className="efiicent-txt">
                                            <h3>100% Copper Motor</h3>
                                            <p>Designed for maximum durability, the 100% Copper winding minimizes energy loss and
                                                maximizes motor life, delivering consistent airflow. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-4">
                                <div className="exhaustcntr-img">

                                    <video src="https://colorbots3.s3.ap-south-1.amazonaws.com/exhaust/Untitled video - Made with Clipchamp (2).mp4 " loop autoplay muted ></video>
                                </div>
                            </div>

                            <div className="col-lg-4">
                                <div className="exhaust-card1">
                                    <div className="efiicent-motor">
                                        <div className="efiicnt-img"><img src="https://colorbots3.s3.ap-south-1.amazonaws.com/exhaust/AirSuction-icn.svg" alt="" /></div>
                                        <div className="efiicent-txt">
                                            <h3>Higher Air Suction</h3>
                                            <p>With higher air suction capacity of 250 to 265 CMH, the Colorbot BLDC exhaust fans
                                                can rapidly ventilate your space by removing any kind of smoke</p>
                                        </div>
                                    </div>

                                    <div className="efiicent-motor">
                                        <div className="efiicnt-img"><img src="https://colorbots3.s3.ap-south-1.amazonaws.com/exhaust/Noiseless-icn.svg" alt="" /></div>
                                        <div className="efiicent-txt">
                                            <h3>Noiseless Performance</h3>
                                            <p>With BLDC technology and sturdy built quality, these fans offer whisper-quite
                                                performance. </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section>
                    <div className="container">
                        <div className="row marg-imgs">
                            <div className="col-lg-4">
                                <div className="img-tiles1">
                                    <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/exhaust/sleek-design.png" alt="" />
                                    <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/exhaust/Silent-operation.png" alt="" />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="img-tiles1">
                                    <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/exhaust/bldc-brillian.png" alt="" />
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="img-tiles1">
                                    <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/exhaust/sleek-design.png" alt="" />
                                    <img src="https://colorbots3.s3.ap-south-1.amazonaws.com/exhaust/Silent-operation.png" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="tiles4-hed-bg">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="tiles4-hed">
                                    <h2>Colorbot BLDC Exhaust Fans</h2>
                                    <p>Enjoy ultimate freshness at minimum electricity bill with Colorbot BLDC Exhaust fans, the
                                        Ultimate Ventilation Solution for your home.</p>
                                </div>
                            </div>

                            <div className="col-lg-3">
                                <div className="free-ship">
                                    <div className="efiicnt-img"><img src="https://colorbots3.s3.ap-south-1.amazonaws.com/exhaust/ship-icon.svg" alt="" /></div>
                                    <div className="efiicent-txt">
                                        <h3>Free Shipping</h3>
                                        <p>Order now and enjoy Free Shipping anywhere in India!</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="free-ship">
                                    <div className="efiicnt-img"><img src="https://colorbots3.s3.ap-south-1.amazonaws.com/warranty.svg" alt="" /></div>
                                    <div className="efiicent-txt">
                                        <h3>Extended Warranty</h3>
                                        <p>On all fans, get 2+2* years of extended Product warranty.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="free-ship">
                                    <div className="efiicnt-img"><img src="https://colorbots3.s3.ap-south-1.amazonaws.com/easy-installation.svg" alt="" /></div>
                                    <div className="efiicent-txt">
                                        <h3>Easy Installation</h3>
                                        <p>Set it up in a jiffy. Avail of a quick and hassle-free installation.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="free-ship">
                                    <div className="efiicnt-img"><img src="https://colorbots3.s3.ap-south-1.amazonaws.com/24-hours-support.svg" alt="" /></div>
                                    <div className="efiicent-txt">
                                        <h3>Customer Support</h3>
                                        <p>24*7, round the clock. Quick and prompt support, anytime, anywhere.</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
                <div className="pt-4 pb-4" style={{ backgroundColor: "#ffffff" }}>
                    <FadeInSection>
                        <div className="container">
                            <div className="row mt-5 mb-5 ">
                                <div className="col-md-12">
                                    <h2 className="cate-blw-colorbot-hed">Buy Exhaust Fans Online in India: High-Performance Ventilation Solutions</h2>
                                    <p className="cate-blw-colorbot-cont">
                                        Enhance the air quality in your home or office with Colorbot Exhaust Fans. Designed for superior ventilation, these high-efficiency fans help remove unwanted odors, humidity, and pollutants, ensuring a fresh and healthy environment.
                                        <br /><br />
                                        At Colorbot, we recognize the importance of proper air circulation in enclosed spaces. Traditional exhaust fans can be noisy, inefficient, and may not complement your modern interiors. This is where Colorbot exhaust fans come in!
                                        <br /><br />
                                        These <NavLink to="/exhaust-fan">high-performance exhaust fans</NavLink> are engineered with advanced technology to deliver powerful air extraction while consuming minimal energy. Whether for kitchens, bathrooms, or commercial spaces, these fans ensure effective ventilation, keeping your indoor spaces fresh and odor-free.
                                        <br /><br />
                                        Experience seamless airflow with Colorbot's range of exhaust fans. Read on to discover why they are the best choice for your ventilation needs.
                                        <br /><br />
                                    </p>

                                    <h2 className="cate-blw-colorbot-cont-h2">Benefits of Buying Colorbot Exhaust Fans</h2>
                                    <p className="cate-blw-colorbot-cont">Colorbot exhaust fans come with cutting-edge features tailored to meet various ventilation needs. With modern design and advanced technology, these fans provide optimal air circulation while maintaining energy efficiency.</p>

                                    {showMore ? <>
                                        <h3 className="cate-blw-colorbot-cont-h3"> Energy Efficiency: </h3>
                                        <p className="cate-blw-colorbot-cont">Colorbot exhaust fans are designed to consume minimal power while providing maximum airflow. These energy-efficient fans help maintain air quality without increasing electricity costs.</p>

                                        <h3 className="cate-blw-colorbot-cont-h3"> Powerful Air Extraction: </h3>
                                        <p className="cate-blw-colorbot-cont">Equipped with high-speed motors, Colorbot exhaust fans ensure effective removal of stale air, smoke, and humidity, making them ideal for kitchens, bathrooms, and workspaces.</p>
                                    </> : ""}

                                    <p className="text-center mt-4">
                                        <button className="btn view" onClick={() => {
                                            setShowMore(!showMore)
                                        }}>{showMore ? "View Less" : "View More"}</button>
                                    </p>
                                    <br />
                                </div>

                            </div>
                        </div>
                    </FadeInSection>
                </div>

            </>
    )
}
export default ExhaustFanTurbo;